import { Link, Breadcrumbs as MuiBreadcrumbs } from '@mui/material'
import { BaseTesto } from '@lucan/base-ui'

export default function Breadcrumbs(props) {
  const { sequenzaRoutes } = props

  if (!sequenzaRoutes || sequenzaRoutes.length === 0) return null

  return (
    <MuiBreadcrumbs>
      {sequenzaRoutes.map(({ label, pathAssoluto }, index) =>
        pathAssoluto ? (
          <Link
            href={pathAssoluto}
            key={index}
            sx={{ fontWeight: 600, fontSize: '1rem' }}
            underline='always'
          >
            {label}
          </Link>
        ) : (
          <BaseTesto
            inline
            key={index}
            sx={{ fontSize: '1rem' }}
          >
            {label}
          </BaseTesto>
        )
      )}
    </MuiBreadcrumbs>
  )
}